<template>    
    <div id="containerInstallAsPwa" 
         class="my-5" >
            <a target="_blank" 
               @click="clickLink"
               id="btnInstallPwa"
               :class="this.class" >
                {{$t("installApp")}}
            </a>
    </div>
</template>
<script>
    import SharedMixin from './../../mixins/SharedMethods'
    export default {
        name: 'TheContainerPWA',
        mixins: [SharedMixin],
        computed: {          
            class() {                
                return `btn btn-link btn-block ${this.disableInstall ? 'isDisabled': ''}`;
            },
            disableInstall() {
                var needToDisable = navigator.userAgent.includes('SamsungBrowser');
                if (needToDisable) this.alertIncompatibility();
                return needToDisable;
            }
        },
        methods: {
            alertIncompatibility: function () {
                this.showAlert(this.$t('installAppDisabled'), "warning", false);
                window.scrollTo(0, 0);
            },
            clickLink: function () {
                this.disableInstall
                    ? this.alertIncompatibility()
                    : window.open(`${this.$store.state.origin}${this.$store.state.appCode}install`, '_blank');
            }
        },
        mounted() {
            if (!window.matchMedia('(display-mode: standalone)').matches) {
                document.getElementById("containerInstallAsPwa").style.display = "block";
            }
        }
    }
</script>
<style>
    .isDisabled, .isDisabled:hover, .isDisabled:focus, .isDisabled:active {
        color: currentColor !important;
        display: inline-block !important;
        text-decoration: none !important;
        cursor: not-allowed !important;
        opacity: 0.5 !important;
        pointer-events: inherit !important;
    }
</style>